 <template>
  <!-- new code -->
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar class="toolbar">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Edit Single Word Assignment</v-toolbar-title>
        <!-- <v-toolbar-items>
            <v-btn dark text @click="show = false">Close</v-btn>
          </v-toolbar-items> -->
      </v-toolbar>
      <div>
        <v-snackbar
          v-model="snackbar"
          :top="true"
          :color="color"
          :timeout="6000"
        >
          <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
          <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card>
          <!-- <br /> -->
          <!-- <span class="slide">*NOTE:Question And Option Image File size Should be less than {{imagesize_new}} KB And It Should be in  <span v-for="(img,index) in imagetype_new" :key="index"> {{img.imagetype}} </span>Format!!!</span> -->
          <!-- <br /> -->

          <v-card class="box">
            <span v-if="imageSizeFlag">
              <v-col cols="12" xs="12" sm="12">
                <center>
                  <p class="slide">
                    Question File size should be less than
                    {{ imagesize_new }}KB!
                  </p>
                </center>
              </v-col>
            </span>
            <span v-if="imageTypeFlag">
              <v-col cols="12" xs="12" sm="12">
                <center>
                  <p class="slide">
                    Question File in
                    <span v-for="(img, index) in imagetype_new" :key="index">
                    </span
                    >Format!!!
                  </p>
                </center>
              </v-col>
            </span>

            <center>
              <span class="text">
                <h6><strong>Problem Statement</strong></h6>
              </span>
            </center>
            <v-row justify="center">
              <v-col cols="12" sm="3" md="3">
                <v-text-field
                  color="#0F2027"
                  label="Weightage"
                  v-model.trim="weightage_edit"
                  type="number"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="6" md="6">
                <ckeditor
                  v-model="question_edit"
                  :config="editorConfig"
                ></ckeditor>
              </v-col>
              <v-col cols="12" sm="1" md="1"> </v-col>
              <v-col cols="12" sm="2" md="2">
                <v-file-input
                  v-model="file_edit"
                  accept="image/jpeg, image/jpg"
                  prepend-icon="mdi-attachment"
                  label="Choose File"
                  show-size
                  name="doc"
                ></v-file-input>
                <span v-if="que_file">
                    <a
                      class="p-2"
                      :href="basepath +que_file"
                      target="blank"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            v-if="que_file != null"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="black">mdi-eye</v-icon></v-btn
                          >
                        </template>
                        <span> View Previous Question File!!! </span>
                      </v-tooltip>
                    </a>
                  </span>
                  <span v-if="que_file != null">
                    <v-btn
                      color="error"
                      fab
                      x-small
                      outlined
                      icon
                      @click="deletedialog('question_file')"
                    >
                      <v-avatar style="" class="delete-avatar">
                        <v-icon color="erro" class="delete-v-icon"
                          >delete</v-icon
                        >
                      </v-avatar>
                    </v-btn>
                  </span>

                <!-- <br />
                <span v-if="que_file != null"> 
                  {{que_file_link}}
                  Previous File <br />
                  <img
                    class="imgs"
                    :src="basepath + que_file"
                    @click="zooimg(basepath + que_file)"
                  />
                  <v-icon
                    title="Delete File"
                    large
                    color="red"
                    @click="deletedialog(que_id)"
                    >mdi-delete-circle</v-icon
                  >
                </span> -->
              </v-col>
            </v-row>
            <br />
            <v-row dense justify="center">
              <v-col cols="12" sm="6" md="4"> 
                <v-text-field
                  v-model="correctanswer"
                  :rules="[(v) => !!v || 'Answer is required']"
                  outlined
                  label="Single Word Answer"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>

          <v-row justify="center">
            <v-btn class="button" @click="saveEditedQuestion()">Update</v-btn>
            <v-btn class="button" @click="show = false">Cancel</v-btn>
          </v-row>
          <br />
        </v-card>
        <div class="text-center">
          <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                Please Wait
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog_delete_que" persistent max-width="700px">
            <v-card class="card-container">
              <v-container>
                <input type="hidden" v-model="deleteItem.delete_id" />
                <h2>
                  <strong
                    >Are you sure you want Delete this Question File???</strong
                  >
                </h2>
                <br/>
                 <v-row dense justify="center">
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_delete_que = false"
                  rounded
                  >No</v-btn
                >
                <v-btn color="red darken-1" text @click="removeoptfile()" rounded
                  >Yes</v-btn
                >
                 </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </div>
        <v-dialog v-model="dialog_zooimg" persistent max-width="800px">
          <v-card>
            <v-card-title>
              <span class="headline">Image Pre-View</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <img
                      class="rounded w-100 d-block imgs-preview"
                      :src="img_url"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog_zooimg = false"
                >Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import CanteenMaster from '../../Canteen/Admin/Master/CanteenMaster.vue';
export default {
  components: { CanteenMaster },
  props: ["singleword_id", "value"],
  data: () => ({
    editorConfig: {
      height: "100px",
      extraPlugins: "mathjax",
      mathJaxLib:
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
    },
    marks_list: [
      { id: 1, marks: "1" },
      { id: 2, marks: "2" },
      { id: 3, marks: "3" },
      { id: 4, marks: "4" },
      { id: 5, marks: "5" },
      { id: 6, marks: "6" },
      { id: 7, marks: "7" },
      { id: 8, marks: "8" },
      { id: 9, marks: "9" },
      { id: 10, marks: "10" },
    ],
    checkedNames: "",
    isChecked: false,
    picked: "one",
    loader: false,
    valid: false,
    question_info: null,
    questionid: null,
    quiz_type_list: null,
    dialog_upload: false,
    current_course: null,
    c_id: null,
    course_name: null,
    course_code: null,
    img_url: null,
    dialog_zooimg: false,
    id: null,
    quiztype: null,
    weightage_edit: "",
    question_edit: "",
    file_edit: null,
    opt_file_edit: "",
    isgraded: "",
    duedate: null,
    que_file: "",
    que_id: "",
    imagesize: null,
    imageSizeFlag: false,
    imageTypeFlag: false,
    correctanswer: null,
    dialog_delete_que: false,
    basepath: null,
    correctanswer_id: "",
    deleteItem: {
      delete_id: "",
    },
    imagesize_new: null,
    imagetype_new: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    quizQuestion_id:null,
  }),

  updated: function () {
    console.log("Inside updated");
    this.$nextTick().then(() => {
      if (window.MathJax) {
        console.log("rendering mathjax");
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },
  created() {
    this.basepath = localStorage.getItem("awspath");
  },
  mounted() {
    this.onload();
  },

  methods: {
    deletedialog(item) {
      //alert(item)
      this.dialog_delete_que = true;
      this.deleteItem.delete_id = item;
    },
     removeoptfile() {
      this.dialog_delete_que = false;
      const data = {
        q_id: this.quizQuestion_id,
        filetype: 'question_file',
      };
      this.dialog = true;
      axios
        .post("/LiveClass/deletemtfFile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "File Deleted Successfully"); // show snackbar
            this.onload();
            this.dialog = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("red", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
   
    zooimg(url_img) {
      //alert("zooimg"+url_img)
      this.img_url = url_img;
      this.dialog_zooimg = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showsnackbar(msg, "error", 5000);
    },

    onload() {
      const data = {
        q_id: this.singleword_id,
      };
      axios
        .post("/LiveClass/getQuizQuestionData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.question_edit = res.data.question;
            this.weightage_edit = res.data.weightage;
            this.que_file = res.data.que_file;
            this.que_id = res.data.que_id;
            this.correctanswer = res.data.correctanswer;
            this.correctanswer_id = res.data.correctanswer_id;
            this.quizQuestion_id = res.data.quizQuestion_id;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);
        });
    },
    saveEditedQuestion(opt) {
      let formData = new FormData();
      if (this.question_edit == "" && this.file_edit == "") {
        this.showSnackbar("#b71c1c", "Please Add Question !!!"); // show snackbar
        return;
      }
      if (this.correctanswer == "") {
        this.showSnackbar("#b71c1c", "Please enter the single word answer !!!"); // show snackbar
        return;
      }
      const isAllWhiteSpace = /^\s+$/.test(this.correctanswer);
      if (isAllWhiteSpace) {
        return;
      }
      formData.append("q_id", this.que_id);
      formData.append("question", this.question_edit);
      formData.append("qfile", this.file_edit);
      formData.append("total_weightage", this.weightage_edit);
      formData.append("correctanswer", this.correctanswer);
      formData.append("mwa_id", this.correctanswer_id);
      this.dialog_upload = true;
      axios
        .post("/LiveClass/saveEditSWA", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Question Updated successfully"); // show snackbar
            this.file_edit=null
            this.dialog_upload = false;
            this.onload();
          }
        })
        .catch((error) => {
          this.showSnackbar("green", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style scoped>
  .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }
.btn-submit-align {
  float: right;
}
.toolbar {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}

.btn-submit:hover {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  width: auto;
}

.msg {
  color: red;
}

.btn-submit:hover {
  background-color: #ffb500 !important;
  color: #ffffff !important;
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}

.name {
  color: #ffb500;
  font-weight: bold;
  letter-spacing: 1px;
}

v-chip {
  width: auto;
}
.text {
  color: darkblue !important;
}
.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
  border: 2px solid rgb(195, 214, 218) !important;
  border-radius: 10px;
}
.textq {
  color: rgb(24, 155, 68) !important;
}
.textd {
  color: rgb(168, 173, 196) !important;
}
.textg {
  color: #ffb500 !important;
}
</style>

 
 
 
 
 
 
 
 
 
 
 
 
 
 